import { createContext } from "react";

import { AlaffiaClient } from "@alaffia-technology-solutions/client-sdk";

import { graphCache } from "../graphCache";

let alaffiaClient: AlaffiaClient | null = null;

export const AlaffiaClientContext = createContext<AlaffiaClient>(
  (() => {
    const alaC = new AlaffiaClient({
      apiUrl: `${process.env.REACT_APP_API_URL}`,
      alafedApiUrl: `${process.env.REACT_APP_ALAFED_API_URL}`,
      graphqlOptions: {
        cacheExchangeOptions: graphCache,
        includeDevtoolsExchange: true,
      },
      logLevel: "info",
    });
    alaffiaClient = alaC;
    return alaC;
  })(),
);

export const getAlaffiaClient = () => {
  return alaffiaClient;
};
